var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type == 'en')?_c('english-push'):_c('chinese-push')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }